"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

// Libraries
// --------------------------------------------------
// Components
// --------------------------------------------------
var Loading =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Loading, _React$Component);

  function Loading() {
    (0, _classCallCheck2["default"])(this, Loading);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Loading).apply(this, arguments));
  }

  (0, _createClass2["default"])(Loading, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !nextProps.loading || nextProps.alwaysUpdate;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          loading = _this$props.loading,
          Component = _this$props.as,
          children = _this$props.children,
          props = (0, _objectWithoutProperties2["default"])(_this$props, ["loading", "as", "children"]);

      if (!loading) {
        return children();
      } else if (!Component) {
        return null;
      } else if (_react["default"].isValidElement(Component)) {
        return Component;
      }

      return _react["default"].createElement(Component, props);
    }
  }]);
  return Loading;
}(_react["default"].Component); // --------------------------------------------------
// Props
// --------------------------------------------------


Loading.propTypes = {
  children: _propTypes["default"].func.isRequired,
  loading: _propTypes["default"].bool,
  alwaysUpdate: _propTypes["default"].bool,
  as: _propTypes["default"].any
};
Loading.defaultProps = {
  loading: true,
  alwaysUpdate: false,
  as: null
};
var _default = Loading;
exports["default"] = _default;